"use strict";
// @ts-ignore
try {
    self['workbox:core:5.1.2'] && _();
}
catch (e) { }
